import styles from './Header.module.scss';
import logo from '../../assets/logo.png';
import search from '../../assets/search.png';
import hamburger from '../../assets/header/hamburger.png';
import basket from '../../assets/header/basket.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useMemo, useRef, useState } from 'react';
import { throttle } from 'lodash';
import SearchModal from '../SearchModal/SearchModal';
import { isDesktop, isMobile } from 'react-device-detect';
import { loginCheck, logout } from '../../auth/auth';
import KakaoBanner from '../../components/KakaoBanner/KakaoBanner';
import { loginConfirm } from '../../common/loginConfirm';
import SideMenuMobile from '../../mobileComponents/SideMenuMobile/SideMenuMobile';
import { useTranslation } from 'react-i18next';
import direct from '../../assets/direct.png';
function Header() {
  const location = useLocation();
  const [isSmallType, setIsSmallType] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const navigate = useNavigate();
  const movingBarRef = useRef<HTMLDivElement>(null);
  function handleNavigationBarMove(
    e: React.MouseEvent<HTMLLIElement, MouseEvent>,
  ) {
    if (!movingBarRef.current) return;
    movingBarRef.current.style.left = e.currentTarget.offsetLeft + 'px';
    movingBarRef.current.style.width = e.currentTarget.offsetWidth + 'px';
  }
  function handleNavigationBarHide(
    e: React.MouseEvent<HTMLUListElement, MouseEvent>,
  ) {
    if (!movingBarRef.current) return;
    movingBarRef.current.style.width = '0px';
  }
  function handleLogout() {
    logout();
    window.location.href = '/';
  }
  const handleScroll = useMemo(
    () =>
      throttle(() => {
        if (window.scrollY > 50) setIsSmallType(true);
        else setIsSmallType(false);
      }, 200),
    [],
  );
  useEffect(() => {
    if (!isDesktop) return;
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
  useEffect(() => {
    if (loginCheck()) setIsLogin(true);
    else setIsLogin(false);
  }, []);
  const [mobileSideOpen, setMobileSideOpen] = useState(false);

  const { t, i18n } = useTranslation();

  const connectToChannelIO = () => {
    if ((window as any).ChannelIO) (window as any).ChannelIO('openChat');
  };
  return (
    <>
      {isDesktop ? (
        <>
          <div
            className={`${styles.heighter}`}
            // style={{ height: '131px' }}
            style={{ height: '187px' }}
          ></div>
          <div
            className={`${styles.container} ${
              isSmallType ? styles.tiny : ''
            } container`}
          >
            <div className={styles.channelBanner} onClick={connectToChannelIO}>
              Connect to customer service
              <img src={direct} alt="direct" />
            </div>
            <div className={styles.header}>
              <img
                src={logo}
                alt="logo"
                className={styles.logo}
                onClick={() => navigate('/')}
              />
              {/* <form
                className={styles.searchForm}
                onClick={() => setSearchOpen(true)}
              >
                <input type="text" placeholder="보감비책 1:1 맞춤 처방?" />
                <img src={search} alt="search" />
              </form> */}
              <ul className={styles.btns}>
                <li>
                  <Link to="/basket">{t('myPage.19')}</Link>
                </li>
                <li>
                  {!isLogin &&
                  location.pathname !== '/join' &&
                  location.pathname !== '/login' ? (
                    <Link
                      to={`/login?rurl=${location.pathname + location.search}`}
                    >
                      {t('header.6')}
                    </Link>
                  ) : !isLogin &&
                    (location.pathname === '/join' ||
                      location.pathname === '/login') ? (
                    <Link to={`/login${location.search}`}>{t('header.6')}</Link>
                  ) : (
                    <a href="#none" onClick={handleLogout}>
                      {t('header.7')}
                    </a>
                  )}
                </li>
                <li>
                  {!isLogin &&
                  location.pathname !== '/join' &&
                  location.pathname !== '/login' ? (
                    <Link
                      to={`/join?rurl=${location.pathname + location.search}`}
                    >
                      {t('header.9')}
                    </Link>
                  ) : !isLogin &&
                    (location.pathname === '/join' ||
                      location.pathname === '/login') ? (
                    <Link to={`/join${location.search}`}>{t('header.9')}</Link>
                  ) : (
                    <Link to="/myPage">{t('header.8')}</Link>
                  )}
                  {/* {!isLogin ? (
                    <Link
                      to={`/join?rurl=${location.pathname + location.search}`}
                    >
                      {t('header.9')}
                    </Link>
                  ) : (
                    <Link to="/myPage">{t('header.8')}</Link>
                  )} */}
                </li>
              </ul>
            </div>
            <div className={styles.navigation}>
              <ul onMouseLeave={(e) => handleNavigationBarHide(e)}>
                <li
                  onMouseEnter={(e) => handleNavigationBarMove(e)}
                  onClick={() => navigate(`/companyInfo`)}
                >
                  <span>DIET DOCTOR</span>
                </li>
                <li
                  onMouseEnter={(e) => handleNavigationBarMove(e)}
                  onClick={() => navigate('/productList')}
                >
                  <span>{t('header.10')}</span>
                  {/* <ul>
                    <li
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate('/productList');
                      }}
                    >
                      {t('productList.1')}
                    </li>
                    <li
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate('/productList?cuid=487');
                      }}
                    >
                      {t('productList.2')}
                    </li>
                    <li
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate('/productList?cuid=488');
                      }}
                    >
                      {t('productList.3')}
                    </li>
                  </ul> */}
                </li>
                <li
                  onMouseEnter={(e) => handleNavigationBarMove(e)}
                  // onClick={() => {
                  //   if (!isLogin) navigate('/event');
                  //   else navigate('/review/all');
                  // }}
                  onClick={() => navigate('/review/all')}
                >
                  <span>{t('header.11')}</span>
                  <ul>
                    <li
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate('/notice');
                      }}
                    >
                      {t('header.1')}
                    </li>
                    <li
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate('/event');
                      }}
                    >
                      {t('header.2')}
                    </li>
                    <li
                      onClick={(e) => {
                        e.stopPropagation();
                        // if (!loginConfirm()) return;
                        navigate('/review/all');
                      }}
                    >
                      {t('header.3')}
                    </li>
                    <li
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate('/faq');
                      }}
                    >
                      {t('header.4')}
                    </li>
                  </ul>
                </li>
                <div ref={movingBarRef} className={styles.movingBar}></div>
              </ul>
            </div>
            {/* <KakaoBanner /> */}
          </div>
          {searchOpen && <SearchModal setOpen={setSearchOpen} />}
        </>
      ) : (
        <>
          <div
            className={`${styles.channelBanner} ${
              isMobile ? styles.isMobile : ''
            }`}
            onClick={connectToChannelIO}
          >
            Connect to customer service.
            <img src={direct} alt="direct" />
          </div>
          <div className={styles.mContainer}>
            <img
              src={logo}
              alt="logo"
              className={styles.logo}
              onClick={() => navigate('/')}
            />
            <div className={styles.btns}>
              {/* <img src={search} alt="search" className={styles.search} /> */}
              <img
                src={basket}
                alt="basket"
                className={styles.basket}
                onClick={() => navigate('/basket')}
              />
              <img
                src={hamburger}
                alt="hamburger"
                className={styles.hamburger}
                onClick={() => setMobileSideOpen(true)}
              />
            </div>
          </div>
          <div className={styles.mHeighter}></div>
          {mobileSideOpen && <SideMenuMobile isOpen={setMobileSideOpen} />}
        </>
      )}
    </>
  );
}
export default Header;
